import Nav from "./nav"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
})
